import React, { useState } from 'react';
import { Modal } from "./Modal";

export function useModal(onClose?: () => void, isMessage?: boolean): [(showJsx?: JSX.Element, titleId?: string) => void, JSX.Element, () => void, (titleId: string) => void] {

    const [jsx, setJsx] = useState<JSX.Element>();
    const [title, setTitle] = useState<string>();

    const [enable, setEnable] = useState(false);

    function creatModal(showJsx?: JSX.Element, titleId?: string, showTools?: (title: JSX.Element) => JSX.Element) {
        setJsx(showJsx);
        setTitle(titleId);
        setEnable(true);
    }

    return [creatModal, (
        <Modal
            
            titleId={title}
            enable={enable}
            onClick={() => {
                setEnable(false);
                if (onClose) onClose();
            }}
            isMessage={isMessage}
        >
            {jsx ? jsx : ""}
        </Modal>
    ), () => {
        setEnable(false);
        if (onClose) onClose();
    }, (titleId: string) => {
        setTitle(titleId);
    }]
}